import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var wellnessIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.138 3.059a1.308 1.308 0 0 1 1.724 0l.103.09c1.082.956 3.821 3.677 4.624 7.228 3.232-2.387 5.153-1.836 5.377-1.76.748.149 1.172.827.993 1.704-.5 2.478-2.846 10.602-11.926 11.032h-.066C2.887 20.923.542 12.799.04 10.32c-.179-.876.246-1.554 1.083-1.726.146-.018 1.97-.195 4.413 1.199l-.048.084a1.393 1.393 0 0 1-1.723.612c-1.069-.434-1.874-.503-2.234-.51l-.127-.001c.378 1.915 2.065 8.006 8.173 9.594-2.195-2.2-3.349-4.57-3.397-7.072-.09-4.7 3.772-8.415 4.958-9.441ZM12 4.17c-1.13.99-4.492 4.283-4.416 8.302.05 2.51 1.433 4.915 4.114 7.152a.49.49 0 0 0 .62-.001c2.665-2.237 4.05-4.641 4.098-7.151.076-4.018-3.285-7.311-4.416-8.302Zm10.504 5.774c.002.002-1.687-.432-4.7 2.046.007.17.02.338.015.509-.048 2.502-1.2 4.873-3.397 7.072 6.044-1.571 7.76-7.55 8.16-9.531a.611.611 0 0 0 .011-.067Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { wellnessIcon as default };
//# sourceMappingURL=wellnessIcon.js.map
